import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./components/ui/toast";
import ScrollToTop from "./components/layout/ScrollToTop";
import GlobalAdBanner from "./components/layout/GlobalAdBanner";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import LeasingLoansPage from "./pages/LeasingLoansPage";
import LeasingLoansDetailPage from "./pages/LeasingLoansDetailPage";
import ContactPage from "./pages/ContactPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import BranchesPage from "./pages/BranchesPage";
import LoginPage from "./pages/LoginPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import NewsListPage from "./pages/admin/NewsListPage";
import NewsEditorPage from "./pages/admin/NewsEditorPage";
import AdManagement from "./components/admin/AdManagement";
import MessagesPage from "./pages/admin/MessagesPage";
import UsersPage from "./pages/admin/UsersPage";
import SettingsPage from "./pages/admin/SettingsPage";
import BranchesManagementPage from "./pages/admin/BranchesManagementPage";
import CareersManagementPage from "./pages/admin/CareersManagementPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <HelmetProvider>
          <ToastProvider>
            <div className="App">
              <BrowserRouter>
                <ScrollToTop />
                <GlobalAdBanner />
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about/:section" element={<AboutPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/products/leasing-loans" element={<LeasingLoansPage />} />
                  <Route path="/products/leasing-loans/:slug" element={<LeasingLoansDetailPage />} />
                  <Route path="/products/:slug" element={<ProductDetailPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/news" element={<NewsPage />} />
                  <Route path="/news/:slug" element={<NewsDetailPage />} />
                  <Route path="/branches" element={<BranchesPage />} />
                  <Route path="/category/news-and-events" element={<NewsPage />} />
                  <Route path="/sustainability" element={<AboutPage />} />
                  <Route path="/our-reach" element={<AboutPage />} />
                  <Route path="/csr" element={<AboutPage />} />
                  <Route path="/financial-info" element={<AboutPage />} />
                  <Route path="/credit-rating" element={<AboutPage />} />
                  <Route path="/tenders" element={<ProductsPage />} />
                  <Route path="/auctions" element={<ProductsPage />} />
                  <Route path="/sales" element={<ProductsPage />} />
                  <Route path="/tender-calendar" element={<ProductsPage />} />
                  <Route path="/applications" element={<ProductsPage />} />
                  <Route path="/careers" element={<ContactPage />} />

                  {/* Auth Routes */}
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/admin/login" element={<AdminLoginPage />} />

                  {/* Admin Routes */}
                  <Route path="/admin" element={<AdminDashboardPage />} />
                  <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                  <Route path="/admin/news" element={<NewsListPage />} />
                  <Route path="/admin/news/new" element={<NewsEditorPage />} />
                  <Route path="/admin/news/edit/:slug" element={<NewsEditorPage />} />
                  <Route path="/admin/ads" element={<AdManagement />} />
                  <Route path="/admin/contacts" element={<MessagesPage />} />
                  <Route path="/admin/users" element={<UsersPage />} />
                  <Route path="/admin/settings" element={<SettingsPage />} />
                  <Route path="/admin/branches" element={<BranchesManagementPage />} />
                  <Route path="/admin/careers" element={<CareersManagementPage />} />

                  {/* Fallback */}
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </BrowserRouter>
            </div>
          </ToastProvider>
        </HelmetProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
